import styled from "styled-components";
import { DefaultAndValue } from "../util/restore";
import { EditorHeaderWithPresetChooser } from "./EditorHeaderWithPresetChooser";




interface PresetColorEditorProps {
  label?: string;
  value: DefaultAndValue;
  onChange: (newValue: DefaultAndValue) => void;
}

export function PresetColorEditor(props: PresetColorEditorProps) {
  return GenericColorEditor<DefaultAndValue>(props)
}

interface ColorEditorProps {
  label?: string;
  value: string;
  onChange: (newValue: string) => void;
}

export function ColorEditor(props: ColorEditorProps) {
  return GenericColorEditor<string>(props)
}

interface GenericColorEditorProps<T extends string | DefaultAndValue> {
  label?: string;
  value: T;
  onChange: (newValue: T) => void;
}

function GenericColorEditor<T extends string | DefaultAndValue>(props: GenericColorEditorProps<T>) {
  const { label, value, onChange } = props;

  const isStringValue = (typeof value === 'string');
  const inputValue = isStringValue ? value : value["value"];

  const maybeConvertChange = (v) => {
    if (isStringValue) {
      onChange(v)
    } else {
      onChange({
        default: value.default,
        value: v
      } as T)
    }
  } 

  return (
    <Container>
      <EditorHeaderWithPresetChooser 
        label={label}
        value={value}
        onChange={maybeConvertChange}
      />
      <Input
        type="color"
        value={inputValue}
        onChange={(e) => maybeConvertChange(e.target.value)}
      />
    </Container>
  );
};

// Styled components
const Container = styled.div`
  /* margin-bottom: 1rem; */
`;

const Input = styled.input`
  width: 100px;
  height: 34px;
  padding: 1px 2px;
  border: 1px solid var(--border-color);
  border-radius: 0.25rem;
`;
